import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPersons } from '../../actions/persons/personsgetall'
import { DashboardIconPersonPlus } from '../../common/icons'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { jsError, localized } from '../../common/utils'
import { personsSelector } from '../../reducers'

export function StartingEmployments() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const persons = useSelector(personsSelector)

	const startKey = 'startingEmployments_startDate'
	const endKey = 'startingEmployments_endDate'
	const todayStr = new Date().toISOString().split('T')[0]

	const [startDate, setStartDate] = useState(() => {
		return (
			localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0]
		)
	})

	const [endDate, setEndDate] = useState(() => {
		return (
			localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0]
		)
	})

	const [data, setData] = useState()

	useEffect(() => {
		const fetchPersons = async () => {
			try {
				dispatch(getAllPersons())
			} catch (err) {
				jsError(err)
			}
		}
		fetchPersons()
	}, [dispatch])

	useEffect(() => {
		if (persons) {
			const start = new Date(startDate)
			start.setUTCHours(0, 0, 0, 0)

			const end = new Date(endDate)
			end.setUTCHours(23, 59, 59, 999)

			const filteredPersons = persons.filter((person) => {
				const startDateVal = person.employmentDetails?.startDate

				if (!startDateVal) {
					return false
				}

				const employmentStartDate = new Date(startDateVal)

				return employmentStartDate >= start && employmentStartDate <= end
			})

			const tableData = filteredPersons
				.map((person) => ({
					personName: person.name,
					startDate: new Date(person.employmentDetails.startDate),
					formOfSalary: person.salaryDetails?.formOfSalary,
					payGroup: person.controlDetails?.payGroup,
				}))
				.sort((a, b) => a.startDate - b.startDate)

			setData(tableData)
		}
	}, [persons, startDate, endDate])

	const getFormOfSalaryText = (formOfSalary) => {
		switch (formOfSalary) {
			case 1:
				return t('MonthlySalary', 'Kuukausipalkka')
			case 2:
				return t('HourlySalary', 'Tuntipalkka')
			default:
				return '-'
		}
	}

	const handleStartDateChange = (val) => {
		setStartDate(val)
		localStorage.setItem(startKey, val)
	}

	const handleEndDateChange = (val) => {
		setEndDate(val)
		localStorage.setItem(endKey, val)
	}

	if (!data) {
		return <LoadingContainer />
	}

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<span className="starting-employments-icon">
						<DashboardIconPersonPlus />
					</span>
					<h4 style={{ margin: 0 }}>{t('StartingEmployments', 'Alkavat työsuhteet')}</h4>
				</div>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => handleStartDateChange(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => handleEndDateChange(e.target.value)} />
				</div>
			</div>

			{data.length ? (
				<div style={{ overflowX: 'auto' }}>
					<Table>
						<thead>
							<tr>
								<th>{t('Person', 'Henkilö')}</th>
								<th>{t('EmploymentStarts', 'Työsuhde alkaa')}</th>
								<th>{t('FormOfSalary', 'Palkkausmuoto')}</th>
								<th>{t('PayGroup', 'Maksuryhmä')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((row) => (
								<tr key={row.personName}>
									<td>{row.personName}</td>
									<td>{row.startDate.toLocaleDateString(localized.resolvedLanguage)}</td>
									<td>{getFormOfSalaryText(row.formOfSalary)}</td>
									<td>{row.payGroup ?? '-'}</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			) : (
				<p>({t('NoStartingEmployments', 'Ei alkavia työsuhteita')})</p>
			)}
		</>
	)
}
